// extracted by mini-css-extract-plugin
export default {"container":"t6IPkvQwmEJwif5tWhEq"};